<template>
  <div id="app">
    <el-container>
      <el-header> <top-nav /></el-header>
      <el-main><router-view /></el-main>
      <el-footer>
        <a href="https://beian.miit.gov.cn">
          备案号：沪ICP备12013583号-1
        </a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202008339">
        沪公安网备31011202001146
      </a> ©Copyright 2019 上海精函信息科技有限公司版权所有
      </el-footer>
    </el-container>
    <!--    <el-container>-->
    <!--      <el-header>-->
    <!--        <top-nav />-->
    <!--      </el-header>-->
    <!--      <el-container>-->
    <!--        <router-view />-->
    <!--      </el-container>-->
    <!--    </el-container>-->
  </div>
</template>

<script>
  import topNav from "./components/common/navbar/topNav";
  import { TIMESTAMP } from "../api/localStorageName";
  export default {
    name: "App",
    components: {
      topNav,
    },
    created() {
      const marketId = this.$store.state.marketId;
      const token = this.$store.state.token;
      const userInfo = this.$store.state.userInfo;
      const timestamp = localStorage.getItem(TIMESTAMP);
      const timestampDate = timestamp ? new Date(timestamp) : new Date();
      const nowDateTime = new Date().getTime();
      if (
        !marketId ||
        !token ||
        !timestamp ||
        nowDateTime - timestampDate > 2 * 60 * 60 * 1000
      ) {
        //有缓存的登录信息，且信息有效
        // this.$router.push({ path: "/login/distributor" });
      }
    },
  };
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    /* font-family:"Microsoft YaHei",微软雅黑; */
  }
  html,body{
    height: 100%;
  }
  #app {
    height: 100%;
  }
  .el-container.is-vertical{
    height: 100%;
  }
  .el-submenu .el-menu-item {
    min-width: unset;
  }

  .el-footer{
    height: auto!important;
    font-size: 12px!important;
    padding:10px 0!important;
    text-align: center!important;
  }
  .el-footer a{
    padding:0 10px;
    text-decoration: none;
    color:#333;
  }
  .el-footer a:hover{
    color:#3894ff;
  }
  .el-main{
    padding: 0!important;
  }
  .el-header {
    /* height: 7vh !important;
    line-height: 7vh !important; */
    height: 60px;
    line-height: 60px;
  }
  /*menu-group 菜单title 去除默认 */
  .el-menu-item-group__title {
    display: none !important;
  }
  .el-table__row--level-1 {
    background: #666;
  }
  .el-table__row--level-1 td,
  .el-table__row--level-0 td {
    background: #ede3ed !important;
  }
  .el-table th {
    color: #333 !important;
  }
  .el-menu-item:hover {
    background: #ffebeb !important;
  }

  .el-submenu__title:hover {
    background: #ffebeb !important;
  }
  .el-select {
    width: 100% !important;
  }
  .el-dialog {
    margin-top: 8vh !important;
  }
  .el-form-item .el-form-item {
    margin-bottom: 20px !important;
  }
  .el-button {
    outline: none !important;
    /*margin-right: 10px!important;*/
  }
  .el-button--text {
    margin-right: 0 !important;
  }
  .el-tabs__item.is-active,
  .el-checkbox__input.is-checked + .el-checkbox__label,
  .el-radio__input.is-checked + .el-radio__label {
    color: #5689fe !important;
  }
  .el-tabs__item:hover {
    color: #5689fe !important;
  }
  .el-tabs__active-bar {
    background-color: #5689fe !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner,
  .el-radio__input.is-checked .el-radio__inner {
    background-color: #5689fe !important;
    border-color: #5689fe !important;
  }
  .el-input__inner:hover {
    border-color: #ffcfcf !important;
  }
  .el-input__inner {
    outline: none !important;
  }

  .theme-bg-color {
    background: #5689fe !important;
  }
  .theme-bg-color:hover {
    background: #5689fe !important;
  }
  .color-white {
    color: #ffffff !important;
  }
  .color-white:hover {
    color: #ffffff !important;
  }

  i {
    margin-right: 5px;
  }
  .zxdChangeMerchant .el-input__inner {
    background: rgba(255, 255, 255, 0) !important;
    border: none !important;
  }
  .page-head {
    display: flex;
    padding: 10px 0;
  }
  .page-head .head-right {
    flex: 1;
    text-align: right;
    padding-left: 10px;
    display: flex;
  }
  .page-head .head-right .el-input {
    width: 200px !important;
    margin-right: 10px;
  }
  .el-pagination {
    text-align: right;
    margin-top: 20px !important;
  }
  .unitDialogHead .el-input {
    width: 200px !important;
    margin-right: 10px;
  }

  .unitDialogDiv thead .el-table-column--selection .cell {
    display: none !important;
  }
  .pluPage .el-form-item__content {
    display: flex !important;
  }
  .pluPage .el-input-group__append,
  .el-input-group__prepend {
    background-color: #409eff !important;
    color: #ffffff !important;
  }
  .page-main{
    height: 100%;
    box-sizing: border-box;
    overflow-y: scroll;
  }
  .addPage {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 100);
    box-shadow: 0px 0px 6px 1px rgba(227, 227, 227, 100);
    padding: 26px;
  }
  .page-title {
    font-size: 18px;
    border-bottom: solid 4px #3894ff;
    display: inline-block;
    padding-bottom: 22px;
  }
  .page-header-border {
    border-bottom: 1px solid #e8e8e8;
  }
  .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
  .el-table__body tr.current-row>td {
    background-color: #a0cfff;
  }

  .el-table--striped .el-table__body tr.hover-row.el-table__row--striped>td,
  .el-table__body tr.hover-row>td {
    background-color: #d9ecff !important;
  }

  .el-tree-node:focus>.el-tree-node__content {
    background-color: #d9ecff !important;
  }
  .el-table th{
    background: rgb(231, 237, 254);
  }
  mar-btm20{
    margin-bottom: 20px;
  }
  .el-loading-mask{
    z-index: 5000
  }


  .color-success,
  .color-success:hover {
    color: #67c23a !important;
  }
  .color-primary,
  .color-primary:hover {
    color: #3884ba !important;
  }
  .color-warning,
  .color-warning:hover {
    color: #e6a23c !important;
  }
  .color-primary,
  .color-primary:hover {
    color: #3884ba !important;
  }
  .color-danger,
  .color-danger:hover {
    color: #f56c6c !important;
  }
  .color-info,
  .color-info:hover {
    color: #909399 !important;
  }

  .takePhotoDialog{
    .el-dialog{
      margin-top:5vh!important;
    }
    .el-dialog__body{
      padding:0!important;
    }
  }
  .payPage{
    .el-dialog .el-input {
      //width: 300px !important;
    }
    .el-dialog .el-textarea {
      width: 300px !important;
    }
    .el-dialog .el-select,.el-select .el-input__inner{
      width: 100% !important;
    }
  }
  .commonPage .el-table .el-button+.el-button{
    margin-left: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue